import type { TOC } from '@ember/component/template-only';
import FocusTrapper from 'ember-focus-trapper/components/focus-trapper';
import EmbeddedApp from 'garaje/components/embedded-app';
import UiClassicModalDialog from 'garaje/components/ui/classic/modal-dialog';

interface EmnoLegalTermsModalSignature {
  Element: HTMLDivElement;
  Args: {
    /** Controlled open state, driven by the pod controller. */
    isOpen: boolean;
    /** Fired when the shell should close (backdrop click / Escape). The iframe
     *  itself closes via a `closeModal` message the controller also handles. */
    onClose: () => void;
    /** URL of the emno-fe modal-content route (see url-builder.ts →
     *  `emno.embeddedLegalTermsModalUrl`). */
    modalIframeUrl: string;
  };
}

/**
 * Modal shell for the emno-fe threat-dashboard legal-terms disclaimer
 * (EMNO-720). Body is a nested emno-fe iframe hosting the modal's content
 * page. The pod controller listens on the shared messageBus for
 * `emnoShowLegalTerms` (to open) and `closeModal` (to shut). No context
 * payload — the terms body is static.
 */
export default <template>
  {{#if @isOpen}}
    <UiClassicModalDialog @onClose={{@onClose}} @translucentOverlay={{true}} @containerClass="!max-w-form">
      <FocusTrapper>
        {{! -mx-8 (not -m-8) — mirrors the add-rule modal (EMNO-485): .ember-modal-dialog has no
            vertical padding to cancel, so a negative block margin would leave permanent dead
            space you could only reach by scrolling the modal. Horizontal bleed is still wanted so
            the framed page's own side gutter lines up with the dialog edges. }}
        <EmbeddedApp
          @id="emno-legal-terms-modal"
          @url={{@modalIframeUrl}}
          class="-mx-8"
          data-test-emno-legal-terms-modal-iframe
        />
      </FocusTrapper>
    </UiClassicModalDialog>
  {{/if}}
</template> satisfies TOC<EmnoLegalTermsModalSignature>;
